import { render, staticRenderFns } from "./SimpleChart.vue?vue&type=template&id=93ec42f6&scoped=true"
import script from "./SimpleChart.vue?vue&type=script&lang=js"
export * from "./SimpleChart.vue?vue&type=script&lang=js"
import style0 from "./SimpleChart.vue?vue&type=style&index=0&id=93ec42f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ec42f6",
  null
  
)

export default component.exports